
import { TeamMemberManagement } from "@/components/team/TeamMemberManagement";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const TeamMembers = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate("/login");
      }
    };

    checkAuth();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session) {
        navigate("/login");
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [navigate]);

  return (
    <div className="container py-6 space-y-6">
      <Helmet>
        <title>Team Members - Spotlight Adz</title>
      </Helmet>
      
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Team Members</h1>
          <p className="text-muted-foreground mt-2">
            Manage your team members, assign roles, and update their information.
          </p>
        </div>
      </div>

      <div className="mt-8">
        <TeamMemberManagement />
      </div>
    </div>
  );
};

export default TeamMembers;
